export const BASE_URL = 'https://www.nsplaw.com/backend';
